import Signin from './Signin'
import { observer, inject } from 'mobx-react'

export default inject(stores => ({
  thinking: stores.AuthorizationStore.thinking,
  signin: details => stores.AuthorizationStore.signin(details)
}))(observer(Signin))
